/*
 * Extended version of AddProviderInfo for admin
 * 
 */

import React from 'react';
import { useEffect, useState, Fragment } from "react";

import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { VariableSizeList } from 'react-window';
import { useAlert } from "react-alert";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import { SocialIcon } from 'react-social-icons';

import { Box, Button, Grid, makeStyles, Paper, TextField, Typography } from "@material-ui/core";
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { KeyboardDatePicker } from "@material-ui/pickers";

import WebIcon from '@material-ui/icons/Web';
import Tooltip from '@material-ui/core/Tooltip';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ListSubheader from '@material-ui/core/ListSubheader';
import { useTheme } from '@material-ui/core/styles';

import { countries, countryToFlag } from '../api/countries';
import { States}  from "../api/states";
import { createProvider } from '../api/admin';

import PlacePicker from "../components/PlacePicker";
import LogoUpload from "../components/LogoUpload";
import RequestCategory from "../components/RequestCategory";

import { useInput } from "../utils/useInputHook";

import config from '../config';


const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1, 0),
            width: '100%',
        },
    },
    heading: {
        margin: theme.spacing(1, 0, 2, 0)
    },
    phoneInput: {
        width: '100% !important',
        '&:focus': {
            borderColor: `${theme.palette.primary.main} !important`,
            boxShadow: `0 0 0 1px ${theme.palette.primary.main} !important`
        }
    },
    option: {
        fontSize: 15,
        '& > span': {
            marginRight: 10,
            fontSize: 18,
        },
    },
}));

const LISTBOX_PADDING = 8; // px

function renderRow(props) {
    const { data, index, style } = props;
    return React.cloneElement(data[index], {
        style: {
            ...style,
            top: style.top + LISTBOX_PADDING,
        },
    });
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
    const outerProps = React.useContext(OuterElementContext);
    return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [data]);
    return ref;
}

const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
    const { children, ...other } = props;
    const itemData = React.Children.toArray(children);
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
    const itemCount = itemData.length;
    const itemSize = smUp ? 36 : 48;

    const getChildSize = (child) => {
        if (React.isValidElement(child) && child.type === ListSubheader) {
            return 48;
        }

        return itemSize;
    };

    const getHeight = () => {
        if (itemCount > 8) {
            return 8 * itemSize;
        }
        return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
    };

    const gridRef = useResetCache(itemCount);

    return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
                <VariableSizeList
                    itemData={itemData}
                    height={getHeight() + 2 * LISTBOX_PADDING}
                    width="100%"
                    ref={gridRef}
                    outerElementType={OuterElementType}
                    innerElementType="ul"
                    itemSize={(index) => getChildSize(itemData[index])}
                    overscanCount={5}
                    itemCount={itemCount}
                >
                    {renderRow}
                </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
    );
});

const filter = createFilterOptions();
export default function AdminCreateProvider({ onUpdate, user, providerCategoryTree, categoryList }) {

    const classes = useStyles();
    const alert = useAlert();
    const [loading, setLoading] = useState(false);

    // const [categoryList, setCategoryList] = useState([]);
    const [mapLoading, setMapLoading] = useState(false);

    const { value: name, bind: bindName } = useInput('');
    const { value: contact_email, bind: bindAccountEmail } = useInput('');
    const [data_source, setDatasource] = useState('London dataset');

    const { value: contactName, bind: bindContactName } = useInput('');
    const [contact, setContact] = useState(null);
    const { value: contactRole, bind: bindContactRole } = useInput('');

    const { value: description, bind: bindDescription } = useInput('');
    const [logoFile, setlogoFile] = useState(null);

    const [category, setCategory] = useState(null);
    const [walk_in, setWalkIn] = useState(false);

    // const { value: licenseId, bind: bindLicenseId } = useInput('');
    // const [licenseExpiry, setLicenseExpiry] = useState(null);

    const { value: addressLine1, bind: bindAddressLine1 } = useInput('');
    const { value: street, bind: bindStreet } = useInput('');
    const { value: landmark, bind: bindLandmark } = useInput('');
    const { value: area, bind: bindArea } = useInput('');
    const { value: city, bind: bindCity } = useInput('');
    const [state, setStateValue] = useState({name:"City of London"});
    const [country, setCountry] = useState({ label: "United Kingdom" })
    const [location, setLocation] = useState({ lat: 0, lng: 0 });
    const { value: zipCode, bind: bindZipCode } = useInput('');

    const { value: website, bind: bindWebsite } = useInput('');
    const { value: instagram, bind: bindInstagram } = useInput('');
    const { value: whatsapp, bind: bindWhatsapp } = useInput('');
    const { value: youtube, bind: bindYoutube } = useInput('');
    const { value: facebook, bind: bindFacebook } = useInput('');
    const { value: twitter, bind: bindTwitter } = useInput('');
    const { value: email, bind: bindEmail } = useInput('');
    const { value: linkedin, bind: bindLinkedin } = useInput('');

    const { value: notes, bind: bindNotes } = useInput('');

    const [requestDialogActive, setRequestDialogActive] = useState(false);
    const [dialogValue, setDialogValue] = useState({ parent: '', name: '', description: '' });


    const handleCategoryRequest = (name) => {
        setDialogValue({ ...dialogValue, name })
        setRequestDialogActive(true)
    }

    const handleRequestFormClose = () => {
        setRequestDialogActive(false);
        setDialogValue({ parent: '', name: '', description: '' })
    }

    const onCategoryRequest = (data) => {
        setCategory({ _id: data.parent, id: data.parent, name: data.parent_name || data.name })
        handleRequestFormClose()
    }
    const setFilterStates = (label) => {
        const country =  countries.filter((d) => d.label == label);
        const filterStateData = States.filter((d) => (d.country_code === country[0].code));
        return filterStateData;
        };
    const [filterState, setFilterState] = useState(setFilterStates("United Kingdom"));

    const onCountryChange = (value) => {
        setCountry(value);
        filterStateFun(value.code);
        setStateValue({name:''});
    };

    const filterStateFun = (countryCode) => {
    const filterStateData = States.filter((d) => 
    (d.country_code === countryCode));
    setFilterState(filterStateData);
    };

    // useEffect(() => {
    //     if (!user) {
    //         return
    //     }
    //     getCategories('Provider_category', user.token)
    //         .then(d => setCategoryList(d.filter(e => e.isLeaf).sort((a,b) => (a?.vertical?.name>b?.vertical?.name) ? (a?.parent?.name>b?.parent?.name) ? (a.name>b.name) ? 1 : -1 : -1 : -1)))

    //     //     .then(() => setLoading(false));
    // }, [user])

    let history = useHistory();

    // const handleDateChange = (date) => {
    //     setLicenseExpiry(date);
    // };

    useEffect(() => {
        setMapLoading(true);
        const delayed = setTimeout(async () => {
            console.log('stopped typing, checking location');
            try {
                const combined = [addressLine1, street, area, city, state, country?.label].join(',');
                if (combined === ',,,,,,') {
                    console.log('address same => setting to saved location')
                    return;
                }
                if (combined.length < 5)
                    return;
                console.log(`Fetching new location`)
                const url = (`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(combined)}&key=${config.GOOGLE_MAPS_API_KEY}`);
                const req = await fetch(url);
                const data = await req.json();
                if (data.status === 'OK') {
                    const location = data.results[0].geometry.location;
                    console.log(`Locationfound`, location);
                    setLocation(location)
                } else {
                    console.log('no data?', data);
                    alert.show("Could not find location");
                }
            } catch (e) {
                console.log(e)
            } finally {
                setMapLoading(false);
            }
        }, 3000);
        return () => clearTimeout(delayed)

    }, [addressLine1, street, area, city, state, country, alert])


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name) {
            alert.show("Name is required");
            return;
        }
        // if (!contact_email) {
        //     alert.show("Email is required");
        //     return;
        // }
        // if (!validateEmail(contact_email)) {
        //     alert.show("Enter a valid email address");
        //     return;
        // }
        // if (!contactName) {
        //     alert.show("Contact name is required")
        //     return;
        // }
        // if (!contact) {
        //     alert.show("Contact number is required")
        //     return;
        // }
        // if (!contactRole) {
        //     alert.show("Contact role is required")
        //     return;
        // }
        // if (!description) {
        //     alert.show("Description is required")
        //     return;
        // }
        // if (!!licenseExpiry && licenseExpiry < (new Date())) {
        //     alert.show("License can't have expiry date in past");
        //     return;
        // }
        if (!category?.name) {
            alert.show("Category is requried");
            return;
        }
        // if (!addressLine1) {
        //     alert.show("Address line is requried");
        //     return;
        // }
        // if (!area) {
        //     alert.show("Area is required");
        //     return;
        // }
        // if (!state) {
        //     alert.show("State is requried");
        //     return;
        // }

        const data = {
            name,
            description,
            contact_name: contactName,
            contact_role: contactRole,
            contact_phone_number: contact,
            data_source,
            logoFile,
            // license: licenseId,
            // license_expiry_date: licenseExpiry,
            latitude: location?.lat,
            longitude: location?.lng,
            address_line_1: addressLine1,
            street,
            landmark,
            area,
            city,
            state: state.name,
            country: country.label,
            zip_code: zipCode,
            category_name: category?.name,
            category_id: category?._id,
            walk_in_flag: walk_in,
            contact_email,
            website,
            whatsapp,
            instagram,
            youtube,
            facebook,
            twitter,
            email,
            linkedin,
            notes
        }
        try {
            setLoading(true);
            const res = await createProvider(data, user.token);
            // console.log(res)
            onUpdate(res);
            history.push('/provider-list')
        } catch (e) {
            console.error('E', e);
            alert.show('Failed to update details')
        } finally {
            setLoading(false);
        }
    }

    return (
        <Paper style={{ padding: '1em', width: '100%', maxWidth: 1500, margin: 'auto' }}>
            <Box className={classes.heading}>
                <Typography variant="h5">
                    Create Provider
                </Typography>
            </Box>
            <form className={classes.root} onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={4}>
                        <TextField fullWidth label="Provider Name *" variant="outlined" {...bindName} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField fullWidth label="Contact Name" variant="outlined" {...bindContactName} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField fullWidth label="Contact Email" variant="outlined" {...bindAccountEmail} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Autocomplete fullWidth
                            options={['London dataset','2GIS', 'Google', 'Facebook', 'Instagram']}
                            autoHighlight
                            disableClearable
                            value={data_source}
                            onChange={(e, val) => setDatasource(val)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Data source"
                                    variant="outlined"

                                />
                            )}
                        />
                    </Grid>
                    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{"Mobile numbers: +44 followed by 10 numbers (0 excluded) \n Landline numbers: +44 followed by 10 numbers (0 excluded)"}</span>} placement="bottom-start">
                        <Grid item xs={12} md={4}>

                            <PhoneInput
                                enableSearch
                                value={contact}
                                containerStyle={{ margin: '8px 0' }}
                                inputClass={classes.phoneInput}
                                onChange={setContact}
                                specialLabel="Contact Number"
                                inputProps={{ maxLength: 16 }}
                                country={'gb'}
                            />

                        </Grid>
                    </Tooltip>
                    <Grid item xs={12} md={4}>
                        <TextField fullWidth label="Contact role" variant="outlined" {...bindContactRole} />
                    </Grid>
                    
                    
                    
                    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{"Please try to limit the description to 3 lines"}</span>} placement="bottom-start">
                        <Grid item xs={12} md={6}>
                            <TextField fullWidth label="Description" multiline rows={4}
                                variant="outlined" {...bindDescription} />
                        </Grid>
                    </Tooltip>
                    <Grid item xs={12} md={6}>
                        <LogoUpload defaultImage={logoFile} onChange={setlogoFile} />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            id="category"
                            freeSolo
                            ListboxComponent={ListboxComponent}
                            onChange={(event, newValue) => {
                                // console.log(newValue)
                                if (typeof newValue === 'string') {
                                    // timeout to avoid instant validation of the dialog's form.
                                    setTimeout(() => {
                                        handleCategoryRequest(newValue)
                                        setCategory({ name: newValue })
                                    });
                                } else if (newValue && newValue.inputValue) {
                                    handleCategoryRequest(newValue.inputValue)
                                    setCategory({ name: newValue.inputValue })
                                } else {
                                    setCategory(newValue);
                                }
                            }}
                            value={category}
                            options={categoryList}
                            filterOptions={(options, params) => {
                                const filtered = filter(options, params);
                                if (params.inputValue !== '') {
                                    filtered.push({
                                        inputValue: params.inputValue,
                                        name: `Not found, Request "${params.inputValue}" to be added`,
                                    });
                                }
                                return filtered;
                            }}
                            getOptionLabel={(option) => {
                                // e.g value selected with enter, right from the input
                                if (typeof option === 'string') {
                                    return option;
                                }
                                if (option.inputValue) {
                                    return option.inputValue;
                                }
                                return option.name || '';
                            }}
                            // renderOption={(option) => `.parent?.name && ' » ') || ''}${option.name}`}
                            renderOption={(option) => {
                                return (
                                    <React.Fragment>
                                        {!!option?.vertical?.name && option?.vertical?.name !== option?.parent?.name &&
                                            <Typography>{option?.vertical?.name + ' - '}</Typography>
                                        }
                                        {!!option?.parent?.name &&
                                            <Typography>{option.parent?.name === "Root" ? "" : option?.vertical?.name === option?.parent?.name ? option.parent?.name + ' - ' : "> " + option.parent?.name + ' - '}</Typography>
                                        }
                                        {option?.name !== "Root" &&
                                            <Typography style={{ fontWeight: 'bold', paddingRight: 8 }}> {option.parent?.name === "Root" ? option.name : "> " + option.name}</Typography>
                                        }
                                    </React.Fragment>
                                )
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Category *" margin="normal" variant="outlined" />
                            )}
                        />
                    </Grid>
                    {/* <Grid item xs={6} >
                        <Grid container spacing={1} style={{ alignItems: 'center', justify: 'center', marginLeft: 20, marginTop: 3 }}>
                            <Grid item xs>
                                <Typography variant="h6">Can people freely access your venue(s) anytime during opening hours?</Typography>
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    control={<Checkbox checked={walk_in}
                                        onChange={async (event) => {
                                            setWalkIn(event.target.checked);
                                        }} />}
                                />
                            </Grid>
                        </Grid>
                    </Grid> */}
                    {/* <Grid item xs={12}>
                        <Typography variant="h6">Trade License Information</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth label="Trade License ID" variant="outlined" {...bindLicenseId} />
                    </Grid>
                    <Grid item xs={6}>
                        <KeyboardDatePicker
                            fullWidth
                            inputVariant="outlined"
                            variant="dialog"
                            minDate={new Date()}
                            minDateMessage="License can't have expiry date in past"
                            format="dd/MM/yyyy"
                            label="Expiry date"
                            value={licenseExpiry}
                            onChange={handleDateChange}
                            margin="normal"
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <Typography variant="h6">Company Address</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField fullWidth label="Office No - Floor - Building Name" variant="outlined" {...bindAddressLine1} />
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Street No - Street Name" variant="outlined" {...bindStreet} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Landmark" variant="outlined" {...bindLandmark} />
                            </Grid>

                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Area" variant="outlined" {...bindArea} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth label="City" variant="outlined" {...bindCity} />
                            </Grid>

                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                {/* <TextField fullWidth label="State *" variant="outlined" {...bindState} /> */}
                                <Autocomplete
                                                          id="State"
 
                                    fullWidth
                                    options={filterState}
                                    classes={{ option: classes.option,}}
                                    getOptionLabel={(option) => option.name}
                                    autoHighlight
                                    disableClearable
                                    value={state}
                                    onChange={(e, val) => setStateValue(val)}
                                    renderOption={(option) => (
                                        <Fragment>
                                            {option.name}
                                        </Fragment>
                                        )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="State"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id="country-select"
                                    options={countries}
                                    classes={{
                                        option: classes.option,
                                    }}
                                    disableClearable
                                    autoHighlight
                                    getOptionLabel={(option) => option.label}
                                    value={country}
                                    onChange={(e, option) => onCountryChange(option)}
                                    renderOption={(option) => (
                                        <Fragment>
                                            <span>{countryToFlag(option.code)}</span>
                                            {option.label} ({option.code})
                                        </Fragment>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            label="Country"
                                            variant="outlined"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Postcode" variant="outlined" {...bindZipCode} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center', justify: 'center' }}>
                        <PlacePicker
                            location={location}
                            loading={mapLoading}
                            onChange={setLocation} />
                    </Grid>


                    <Grid item xs={12} style={{marginTop:'15px'}}>
                        <Typography variant="h6">Online Presence</Typography>
                    </Grid>


                    <Grid item xs={12} md={6}>
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <WebIcon style={{ fontSize: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Website"  {...bindWebsite} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="instagram" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Instagram"  {...bindInstagram} />
                            </Grid>
                        </Grid>
                        <Tooltip title="Please enter the general WhatsApp number for the company (not for a specific branch). This WhatsApp number should be available for the public.">
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="whatsapp" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Whatsapp"  {...bindWhatsapp} />
                            </Grid>
                        </Grid>
                        </Tooltip>
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="linkedin" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="LinkedIn"  {...bindLinkedin} />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Tooltip title="Please enter the general email address for the company (not for a specific branch). This email address should be available for the public.">
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="email" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Email"  {...bindEmail} />
                            </Grid>
                        </Grid>
                        </Tooltip>
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="youtube" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Youtube"  {...bindYoutube} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="facebook" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Facebook"  {...bindFacebook} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="twitter" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Twitter" {...bindTwitter} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{marginTop:'15px'}}>
                        <Typography variant="h6" style={{ flex: '1'}}>Notes</Typography>
                    </Grid>
                    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{"Please use this field if there is any additional information from the provider"}</span>} placement="bottom-start">
                        <Grid item xs={12} >
                            <TextField fullWidth multiline rows={4} label="Additional information" variant="outlined" {...bindNotes} />
                        </Grid>
                    </Tooltip>

                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginRight: '8px' }}
                            component={RouterLink}
                            disabled={loading}
                            to="/provider-list">
                            Cancel
                        </Button>
                        <Button variant="contained" type="submit" color="primary" disabled={loading}>
                            {loading ? <CircularProgress color="inherit" className={classes.circularProgress} size={20} /> : 'Save'}
                        </Button>
                    </Grid>
                </Grid>

            </form>
            <RequestCategory
                dialogValue={dialogValue}
                setDialogValue={setDialogValue}
                user={user}
                providerId={null}
                categoryTree={providerCategoryTree}
                open={requestDialogActive}
                handleRequest={onCategoryRequest}
                handleClose={handleRequestFormClose} />
        </Paper>

    );
}